import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Note = styled.div<{ $tone?: "default" | "danger" }>`
    font-size: 0.875rem;
    color: ${({ $tone }) => ($tone === "danger" ? colors.danger : colors.textSecondary)};
`;
